import { render, staticRenderFns } from "./PageAdminInvites.vue?vue&type=template&id=023f1110"
import script from "./PageAdminInvites.vue?vue&type=script&lang=js"
export * from "./PageAdminInvites.vue?vue&type=script&lang=js"
import style0 from "./PageAdminInvites.vue?vue&type=style&index=0&id=023f1110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports